import { Component, Input } from '@angular/core';

/**
 * Small status pill — settled / partial / failed / neutral.
 * Used on remittance preview rows, AP-side balance rows, etc.
 */
@Component({
	selector: 'app-status-pill',
	templateUrl: './status-pill.component.html',
	styleUrls: ['./status-pill.component.scss']
})
export class StatusPillComponent {
	@Input() status: 'settled' | 'partial' | 'failed' | 'neutral' = 'neutral';
	@Input() label: string = '';
	@Input() icon: string | null = null; // Material icon name, optional

	get statusClass(): string {
		switch (this.status) {
		case 'settled': return 'is-settled';
		case 'partial': return 'is-partial';
		case 'failed': return 'is-failed';
		default: return 'is-neutral';
		}
	}
}
